
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recommendations",
      function () {
        return require("private-next-pages/recommendations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recommendations"])
      });
    }
  